import { Link, useNavigate } from 'react-router';
import { useQueryClient } from '@tanstack/react-query';
import { authClient } from '../lib/auth-client';

export default function Layout({ children, fullWidth }: { children: React.ReactNode; fullWidth?: boolean }) {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const handleSignOut = async () => {
    await authClient.signOut();
    queryClient.clear();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="sticky top-0 z-50 glass shadow-ambient">
        <div className="mx-auto flex h-16 max-w-5xl items-center justify-between px-6">
          <nav className="flex items-center gap-8">
            <Link to="/" className="display-tight text-xl font-semibold text-primary">
              Everplan
            </Link>
            <Link
              to="/projects"
              className="label-caps text-xs text-muted-foreground transition-colors hover:text-foreground"
            >
              Projects
            </Link>
            <Link
              to="/vendors"
              className="label-caps text-xs text-muted-foreground transition-colors hover:text-foreground"
            >
              Vendors
            </Link>
            <Link
              to="/settings"
              className="label-caps text-xs text-muted-foreground transition-colors hover:text-foreground"
            >
              Settings
            </Link>
          </nav>
          <button
            onClick={handleSignOut}
            className="label-caps text-xs text-muted-foreground transition-colors hover:text-foreground"
          >
            Sign out
          </button>
        </div>
      </header>
      <main className={fullWidth ? '' : 'mx-auto max-w-5xl px-6 py-10'}>{children}</main>
    </div>
  );
}
